import api from "./api";
import { logger } from "./logger";

const STORAGE_KEY = "rivendas_push_endpoint";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) output[i] = raw.charCodeAt(i);
  return output;
}

export function pushSupported() {
  return typeof window !== "undefined"
    && "serviceWorker" in navigator
    && "PushManager" in window
    && "Notification" in window;
}

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    return await navigator.serviceWorker.register("/sw.js", { scope: "/" });
  } catch (err) {
    logger.warn("SW register failed", err?.message);
    return null;
  }
}

export async function currentPushStatus() {
  if (!pushSupported()) return { supported: false, permission: "denied", subscribed: false };
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  return {
    supported: true,
    permission: Notification.permission,
    subscribed: !!sub,
  };
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("Push não suportado neste navegador");
  const { data } = await api.get("/push/public-key");
  if (!data?.enabled || !data?.public_key) throw new Error("Push desativado no servidor");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Permissão negada");
  const reg = await registerServiceWorker();
  if (!reg) throw new Error("Service worker não disponível");
  await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.public_key),
  });
  const json = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: json.endpoint, keys: json.keys });
  localStorage.setItem(STORAGE_KEY, json.endpoint);
  return true;
}

export async function disablePush() {
  if (!pushSupported()) return;
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  const endpoint = sub?.endpoint || localStorage.getItem(STORAGE_KEY);
  if (sub) { try { await sub.unsubscribe(); } catch { /* ignore */ } }
  try { await api.post("/push/unsubscribe", { endpoint }); } catch { /* ignore */ }
  localStorage.removeItem(STORAGE_KEY);
}
